import React from 'react';
import { Card, Grid } from '@mui/material';

import { Colors } from '../utils/Colors';

interface OcdTypeButtonCardProps {
  icon: any;
  handleClick: () => void;
}

export function OcdTypeButtonCard({
  icon,
  handleClick
}: OcdTypeButtonCardProps) {
  return (
    <Card
      sx={{
        minWidth: '125px',
        height: '150px',
        padding: '15px',
        backgroundColor: Colors.lightGray,
        border: `1px solid ${Colors.silverSand}`,
        borderRadius: '15px',
        boxShadow: 0,
        cursor: 'pointer'
      }}
      onClick={handleClick}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        style={{ height: '100%' }}
      >
        <Grid item>{icon}</Grid>
      </Grid>
    </Card>
  );
}
